/**
 * React Entry Point (ES Module)
 * 
 * This file serves as the primary entry point for React initialization.
 * It ensures React is properly loaded before any other modules use it.
 * 
 * This is a critical fix for the "Cannot read properties of undefined (reading 'createContext')" error
 * that occurs in production builds.
 */

// Import React directly to ensure it's loaded first
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';

// Log React availability for debugging
console.log('[react-entry] React initialization:', {
  version: React?.version || 'undefined',
  available: typeof React !== 'undefined',
  createContextAvailable: typeof React?.createContext === 'function'
});

// Explicitly assign React to window to ensure global availability
if (typeof window !== 'undefined') {
  window.React = React;
  window.ReactDOM = ReactDOM;
  window.ReactDOMClient = ReactDOMClient;
  
  // Create a test context to verify React is working properly
  try {
    const TestContext = React.createContext(null);
    console.log('[react-entry] Context creation test:', TestContext ? 'Success' : 'Failed');
  } catch (error) {
    console.error('[react-entry] Context creation test failed:', error);
  }
}

// Export React for use in other modules
export default React;
export { React, ReactDOM, ReactDOMClient };
